export class FileNotFoundError extends Error {
  constructor(...args: ConstructorParameters<typeof Error>) {
    super(...args);
    this.name = 'FileNotFoundError';
  }
}
